import { useEffect } from "react";
function useValidFieldUpdate(form, onValidFieldUpdate) {
  useEffect(
    () => {
      const {
        unsubscribe
      } = form.watch(async (fields, {
        name: updatedFieldName
      }) => {
        const isFieldValid = await form.trigger(updatedFieldName);
        if (isFieldValid) {
          const name = updatedFieldName;
          const value = fields[updatedFieldName];
          onValidFieldUpdate(name, value);
        }
      });
      return () => {
        unsubscribe();
      };
    },
    // Mount effect, so empty deps is ok
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
export {
  useValidFieldUpdate as default
};
